import { useMemo } from 'react';
import { isReactPage } from 'utils/isReactPage';

export const useIsReactPage = () => useMemo(() => isReactPage(), []);
